import { Button, type ButtonProps } from "@mdotm/shadcn/mdotm/components";
import { toClassListRecord } from "@mdotm/shadcn/legacy/react-extensions";

/** `Extract` picks the sync half of the union; `size` was inert under legacy `unstyled` and is dropped. */
type RoundedButtonProps = Omit<Extract<ButtonProps, { onClickAsync?: never }>, "palette" | "unstyled" | "size">;

function RoundedButton({ className, children, ...rest }: RoundedButtonProps): React.JSX.Element {
	return (
		<Button
			{...rest}
			unstyled
			className={{
				...toClassListRecord(className),
				[`!bg-[var(--palette-N20)] hover:!bg-[var(--palette-P100)] hover:!text-[var(--palette-P600)] !text-[color:var(--palette-N500)] rounded-full p-2`]: true,
			}}
		>
			{children}
		</Button>
	);
}

export default RoundedButton;
